import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../Logo';

const Footer = () => {
  return (
    <footer className="bg-[#0f1115] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2">
            <Link to="/" aria-label="Ascend — Home" className="inline-block">
              <Logo size={64} className="rounded-sm" />
            </Link>
            <p className="mt-4 text-[#9ca3af] max-w-md">
              Land more interviews with AI-optimized resumes. Our ATS scoring system helps you tailor your resume to beat applicant tracking systems.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-satoshi font-bold text-lg mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/free-ats-check" className="text-[#9ca3af] hover:text-white transition-colors">
                  Free ATS Score Checker
                </Link>
              </li>
              <li>
                <Link to="/#features" className="text-[#9ca3af] hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-[#9ca3af] hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-[#9ca3af] hover:text-white transition-colors">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-satoshi font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/blog" className="text-[#9ca3af] hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/blog/how-to-beat-ats-systems" className="text-[#9ca3af] hover:text-white transition-colors">
                  How to Beat ATS
                </Link>
              </li>
              <li>
                <Link to="/blog/ats-resume-format-guide" className="text-[#9ca3af] hover:text-white transition-colors">
                  ATS Resume Format
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-satoshi font-bold text-lg mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-[#9ca3af] hover:text-white transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#9ca3af] hover:text-white transition-colors" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="mailto:hello@ascendforyou.net" className="text-[#9ca3af] hover:text-white transition-colors" data-testid="footer-contact-link">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#374151] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-[#9ca3af] text-sm">
            © {new Date().getFullYear()} AscendForYou.net. All rights reserved.
          </p>
          <div className="flex items-center gap-4 mt-4 md:mt-0">
            <a
              href="https://x.com/AscendForYou"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9ca3af] hover:text-white transition-colors"
              data-testid="social-x"
              aria-label="Follow us on X"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61567607631360"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9ca3af] hover:text-[#1877F2] transition-colors"
              data-testid="social-facebook"
              aria-label="Follow us on Facebook"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a
              href="https://www.linkedin.com/company/ascendforyou/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9ca3af] hover:text-[#0A66C2] transition-colors"
              data-testid="social-linkedin"
              aria-label="Follow us on LinkedIn"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
